module.exports = __webpack_public_path__ + "static/media/red_exclamation_icon.e9a5f648.svg";